import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, queryClient, QueryConfig } from 'lib/react-query';

import { SystemModuleListDto } from 'types';

export const getSystemModules = async (): Promise<
  SystemModuleListDto | undefined
> => {
  const { data }: { data: SystemModuleListDto } = await axios.get(
    `/api/system-modules`
  );
  return data as SystemModuleListDto;
};

type QueryFnType = typeof getSystemModules;

type UseSystemModulesOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useSystemModules = ({ config }: UseSystemModulesOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['systemModules'],
    queryFn: () => getSystemModules(),
    ...config,
    onSuccess: () => {
      queryClient.invalidateQueries(['systemModuleLimits']);
    },
  });
};
